// src/app/shared/utils.service.ts
import { Injectable, inject } from '@angular/core';
import { AWSLambda } from '../AWSLambda.service';

@Injectable({
  providedIn: 'root' // disponible en toda la app
})
export class UtilsService {
  constructor() { }

  lambda = inject(AWSLambda); 

}
